export default [
  {
    text: "Dashboard",
    path: "/simpeg-dashboard",
    icon: "home",
    can: "all",
  },
  {
    text: "Simpeg Dashboard Filter",
    path: "/simpeg-dashboard-filter",
    icon: "home",
    can: "superadmin",
  },

  {
    text: "Data Pegawai",
    icon: "group",
    can: "pegawai-access",
    items: [
      {
        text: "DUK",
        path: "/duk-list",
        can: "pegawai-access",
      },
      {
        text: "Daftar Pegawai",
        path: "/pegawai-list-custom",
        can: "all",
      },
      {
        text: "Tambah Pegawai",
        path: "/simpeg-pegawai-add",
        can: "pegawai-create",
      },
      {
        text: "Daftar Arsip Pegawai",
        path: "/arsip-list",
        can: "all",
      },
      {
        text: "Daftar Pengajuan",
        path: "/pengajuan-list",
        can: "all",
      },
      // {
      //   text: 'Detail Pegawai',
      //   path: '/simpeg-pegawai-detail',
      // },
      // {
      //   text: 'Import Data Pegawai',
      //   path: '/simpeg-pegawai-gaji-import',
      // },
      {
        text: "Daftar Kenaikan Pangkat",
        // path: '/simpeg-naik-pangkat-list',
        path: "/naik-pangkat-list-custom",
        can: "all",
      },
      {
        text: "Daftar Prediksi Kenaikan Pangkat",
        // path: '/simpeg-naikpangkat-prediksi-list',
        path: "/naik-pangkat-prediksi-list-custom",
        can: "all",
      },
      {
        text: "Daftar KGB",
        // path: '/simpeg-kgb-list',
        path: "/kgb-list-custom",
        can: "all",
      },
      {
        text: "Daftar Prediksi KGB",
        // path: '/simpeg-kgb-prediksi-list',
        path: "/kgb-prediksi-list-custom",
        can: "all",
      },

      {
        text: "Daftar Pensiun",
        // path: '/simpeg-pensiun-list',
        path: "/pensiun-list-custom",
        can: "all",
      },
      {
        text: "Daftar Riwayat Pekerjaan",
        // path: '/pekerjaan-list',
        path: "/pekerjaan-list-custom",
        can: "all",
      },
      // {
      //   text: 'Daftar Riwayat PLT',
      //   path: '/list-plt', can: "all",
      // },
      {
        text: "Daftar Pemegang Kendaraan D.",
        // path: '/transport-list',
        path: "/transport-list-custom",
        can: "all",
      },
      {
        text: "Daftar Riwayat Pendidikan",
        // path: '/pendidikan-list',
        path: "/pendidikan-list-custom",
        can: "all",
      },
      {
        text: "Daftar Riwayat Penghargaan",
        path: "/penghargaan-list",
        can: "all",
      },
      {
        text: "Daftar Riwayat Peringatan",
        path: "/peringatan-list",
        can: "all",
      },
      {
        text: "Daftar Diklat",
        path: "/diklat-list",
        can: "all",
      },
      {
        text: "Daftar DP3",
        path: "/dp3-list",
        can: "all",
      },
      // {
      //   text: 'Diklat Print',
      //   path: '/diklat-print',
      //   icon: 'folder'
      // }
    ],
  },

  {
    text: "Data Cuti",
    icon: "event",
    can: "absensi-access",
    items: [
      {
        text: "Daftar Cuti",
        path: "/cuti-list",
        can: "all",
      },
      {
        text: "Pengaturan Cuti",
        path: "/cuti-setting-list",
        can: "all",
      },

      {
        text: "Daftar Hari Libur",
        path: "/libur-list",
        can: "all",
      },
    ],
  },
  {
    text: "Generate Dokumen",
    path: "/generate-document",
    icon: "print",
    can: "pegawai-create",
  },

  {
    text: "Dewan Pengawas",
    icon: "group",
    can: "pegawai-access",
    items: [
      {
        text: "Daftar Dewan Pengawas",
        path: "/dewas-list",
        can: "all",
      },
      {
        text: "Tambah Dewan Pengawas",
        path: "/dewas-add",
        can: "pegawai-create",
      },
      {
        text: "Daftar Arsip Dewan Pengawas",
        path: "/dewas-arsip",
        can: "all",
      },
    ],
  },

  {
    text: "Data Absensi",
    icon: "event",
    can: "absensi-access",
    items: [
      // {
      //   text: 'Daftar Absensi',
      //   path: '/ini-kenapa-ga-bisa-batch',
      // },
      // {
      //   text: 'Daftar Absensi',
      //   path: '/absen-list', can: "all",
      // },
      {
        text: "Daftar Absensi",
        // path: '/absen-list-custom',
        path: "/absen-list-custom",
        can: "all",
      },
      // {
      //   text: 'Input Absensi',
      //   // path: '/absen-bulan-input-final',
      //   path: '/absen-list-custom?action=input',
      //   can: "absensi-create",
      // },
      {
        text: "Import Absensi",
        path: "/absen-bulan-import",
        can: "absensi-create",
      },
    ],
  },

  {
    text: "Penggajian",
    icon: "money",
    can: "gaji-access",
    items: [
      {
        text: "Daftar Periode Penggajian",
        path: "/gaji-periode",
        can: "all",
      },
      {
        text: "Daftar Riwayat Gaji",
        path: "/gaji-history-custom",
        can: "all",
      },

      // {
      //   text: 'Daftar Gaji',
      //   path: '/final-gaji-list-draft',
      // },
      // {
      //   text: 'Generate Gaji',
      //   path: '/final-gaji-baru',
      // },
      {
        text: "Rekap Penggajian",
        path: "/gaji-rekap-v2",
        can: "all",
      },
      {
        text: "Cek Gaji Per Pegawai",
        path: "/cek-gaji",
        can: "all",
      },

      // {
      //   text: 'Rekap Gaji',
      //   path: '/gaji-rekap',
      // },
      // {
      //   text: 'Print Gaji',
      //   path: '/print-gaji',
      // },
      {
        text: "Proyeksi Penggajian",
        path: "/proyeksi-practice",
        can: "superadmin",
      },
      {
        text: "Daftar Skema Penggajian",
        path: "/skema-gaji-list",
        can: "all",
      },

      // {
      //   text: 'Practice Spline Chart',
      //   path: '/practice-spline-chart',
      // }
    ],
  },
  {
    text: "Remote Tables",
    icon: "folder",
    can: "superadmin",
    items: [
      {
        text: "Daftar Pegawai Remote",
        path: "/simpeg-pegawai-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Kenaikan Pangkat Remote",
        path: "/simpeg-naik-pangkat-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar KGB Remote",
        path: "/simpeg-kgb-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Prediksi Kenaikan Pangkat Remote",
        path: "/simpeg-naikpangkat-prediksi-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Prediksi KGB Remote",
        path: "/simpeg-kgb-prediksi-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Pensiun Remote",
        path: "/simpeg-pensiun-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Riwayat Pekerjaan Remote",
        path: "/pekerjaan-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Riwayat Plt Remote",
        path: "/list-plt-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Pemegang Kendaraan D. Remote",
        path: "/transport-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Riwayat Pendidikan Remote",
        path: "/pendidikan-list-remote",
        can: "superadmin",
      },
      {
        text: "Daftar Absensi Remote",
        path: "/absen-list-remote",
        can: "superadmin",
      },
      {
        text: "Input Absensi Remote",
        path: "/absen-bulan-input-final-remote",
        can: "superadmin",
      },
    ],
  },

  {
    text: "Compare Gaji Import Excel",
    path: "/compare-gaji-import-excel",
    icon: "folder",
    can: "superadmin",
  },

  {
    text: "Daftar User",
    path: "/user-list",
    icon: "user",
    can: "superadmin",
  },

  {
    text: "Log Aktivitas User",
    path: "/activity-log",
    icon: "user",
    can: "all",
  },

  {
    text: "Belajar_tagbox",
    path: "/belajar-tagbox",
    icon: "folder",
    can: "superadmin",
  },
  {
    text: "Html To Word Practice",
    path: "/html-to-word-practice",
    icon: "folder",
    can: "superadmin",
  },

  // {
  //   text: 'Login',
  //   path: '/login-form',
  //   icon: 'folder'
  // },

  // {
  //   text: "TESTING PRINT GAJI",
  //   icon: "folder",
  //   items:[
  //     {
  //       text: 'Jspdf Practice',
  //       path: '/jspdf-practice',

  //     },
  //     {
  //       text: 'Print Plain ',
  //       path: '/print-plain',

  //     },
  //     {
  //       text: 'Print Plain Tetap',
  //       path: '/print-plain-tetap',

  //     },
  //     {
  //       text: 'Testing Playground',
  //       path: '/testing-playground',

  //     },
  //     {
  //       text: 'Testing 2',
  //       path: '/testing-2',

  //     },
  //     {
  //       text: 'Testing Page Break Ok',
  //       path: '/testing-page-break-ok',

  //     },
  //     {
  //       text: 'Pring Gaji Query Terpisah Per Tabel',
  //       path: '/pring-gaji-query-terpisah-per-tabel',

  //     },
  //     {
  //       text: 'Print Gaji Tetap OK',
  //       path: '/print-gaji-tetap-ok',

  //     },
  //     {
  //       text: 'Print Gaji Direksi Tetap Honor Kontrak OK',
  //       path: '/print-gaji-direksi-tetap-honor-kontrak-ok',

  //     },
  //     {
  //       text: 'Print Gaji Tetap Unit OK',
  //       path: '/print-gaji-tetap-unit-ok',

  //     }

  //   ]
  // },

  // {
  //   text: "DEMO V2",
  //   icon: "home",
  //   items: [
  // {
  //   text: 'Dashboard',
  //   path: '/simpeg-dashboard',
  // },
  // {
  //   text: "Data Pegawai",
  //   items:[
  // {
  //   text: 'Daftar Pegawai',
  //   path: '/simpeg-pegawai-list',
  // },
  // {
  //   text: 'Tambah Pegawai',
  //   path: '/simpeg-pegawai-add',
  // },
  // {
  //   text: 'Detail Pegawai',
  //   path: '/simpeg-pegawai-detail',
  // },
  // {
  //   text: 'Import Data Pegawai',
  //   path: '/simpeg-pegawai-gaji-import',
  // },
  // {
  //   text: 'Daftar Kenaikan Pangkat',
  //   path: '/simpeg-naik-pangkat-list',
  // },
  // {
  //   text: 'Daftar KGB',
  //   path: '/simpeg-kgb-list',
  // },

  //   ]
  // },
  // {
  //   text: "Data Absensi",
  //   items:[
  // {
  //   text: 'Daftar Absensi',
  //   path: '/ini-kenapa-ga-bisa-batch',
  // },
  // {
  //   text: 'Input Absensi',
  //   path: '/absen-bulan-input-final',
  // },
  // {
  //   text: 'Import Absensi',
  //   path: '/absen-bulan-import',
  // }
  //   ]
  // },
  // {
  //   text: "Penggajian Pegawai",
  //   items:[
  // {
  //   text: 'Daftar Gaji',
  //   path: '/final-gaji-list-draft',
  // },
  // {
  //   text: 'Input Gaji',
  //   path: '/final-gaji-baru',
  // },
  // {
  //   text: 'Rekap',
  //   path: '/gaji-rekap',
  // },
  //   ]
  // },

  //   ]//

  // },

  // {
  //   text: "DEMO V1",
  //   icon: "home",
  //   items: [
  //     {
  //       text: 'FINAL Gaji List',
  //       path: '/final-gaji-list',
  //     } ,
  //     {
  //       text: 'Gaji Baru Pisah',
  //       path: '/gaji-baru-pisah',
  //     },
  //     {
  //       text: 'Gaji List Pisah Updated',
  //       path: '/gaji-list-pisah-updated',
  //     },

  //     {
  //       text: 'Absen Bulan Input',
  //       path: '/absen-bulan-input',
  //     },
  //     {
  //       text: 'Dashboard',
  //       path: '/dashboard-final',
  //       icon: "home"
  //     },
  //     {
  //       text: "Penjagaan",
  //       icon: "folder",
  //       items: [
  //         {
  //           text: 'Kenaikan Gaji Berkala',
  //           path: '/kenaikan-gaji-berkala',
  //         },
  //         {
  //           text: 'Kenaikan Pangkat',
  //           path: '/kenaikan-pangkat',
  //         },
  //         {
  //           text: 'Pegawai Pensiun',
  //           path: '/pegawai-pensiun',
  //         }
  //       ]
  //     },
  //     {
  //       text: 'Pegawai List Odata Filter',
  //       path: '/pegawai-list-odata-filter',
  //       icon: 'folder'
  //     },

  //     {
  //       text: 'Pegawai Add',
  //       path: '/pegawai-add',
  //       icon: 'folder'
  //     },

  //     {
  //       text: 'Pegawai Detail',
  //       path: '/navigation-menu-edit',
  //       icon: 'folder'
  //     },
  //     {
  //       text: "Riwayat Pegawai",
  //       icon: "folder",
  //       items: [
  //         {
  //           text: "Riwayat Pendidikan",
  //           path: "/riwayat-pendidikan"
  //         },
  //         {
  //           text: "Riwayat Keluarga",
  //           path: "/riwayat-keluarga"
  //         }
  //       ]
  //     },
  //   ]//

  // },

  // {
  //   text: "PRACTICE",
  //   icon: "warning",
  //   items: [
  //     {
  //       text: 'dashboard practice',
  //       path: '/responsive-box-practice',
  //     },
  //     {
  //       text: 'Show Images In Vue',
  //       path: '/show-images-in-vue',
  //     },
  //     {
  //       text: 'Image Profile Change',
  //       path: '/image-profile-change',
  //     },
  //     {
  //       text: 'Tooltip Example',
  //       path: '/tooltip-example',
  //     },
  //     {
  //       text: 'Card Like',
  //       path: '/card-like',
  //     },

  //     {
  //       text: 'Table Grid Popup',
  //       path: '/table-grid-popup',
  //     },
  //     {
  //       text: 'Datagrid Date Validation',
  //       path: '/datagrid-date-validation',
  //     },
  //     {
  //       text: 'Pegawai Detail Right',
  //       path: '/pegawai-detail-right',
  //     },
  //     {
  //       text: 'Navigation Menu',
  //       path: '/navigation-menu',
  //     },
  //     {
  //       text: 'Pegawai List JS',
  //       path: '/pegawai-list-js',
  //     },
  //     {
  //       text: 'Pegawai List Odata',
  //       path: '/pegawai-list-odata',
  //     },
  //     {
  //       text: 'Pegawai List Odata Lookup',
  //       path: '/pegawai-list-odata-lookup',
  //     },
  //     {
  //       text: 'Pegawai Riwayat',
  //       path: '/pegawai-riwayat',
  //     },
  //     {
  //       text: 'Pegawai Detail',
  //       path: '/pegawai-detail',
  //     },
  //     {
  //       text: 'Form Data',
  //       path: '/form-data',
  //     },
  //   ]
  // },
  // {
  //   text: "Examples",
  //   icon: "folder",
  //   items: [
  //     {
  //       text: "Profile",
  //       path: "/profile"
  //     },
  //     {
  //       text: "Tasks",
  //       path: "/tasks"
  //     }
  //   ]
  // },
  // {
  //   text: "PRACTICE V2",
  //   icon: "folder",
  //   items: [
  //     {
  //       text: 'Datagrid Odata Crud',
  //       path: '/datagrid-odata-crud',
  //     },
  //     {
  //       text: 'Filtering Date Practice',
  //       path: '/filtering-date-practice',
  //     },
  //     {
  //       text: 'DxDateBoxFilterCell',
  //       path: '/dx-date-box-filter-cell',
  //     },

  //     {
  //       text: 'Simpeg Pegawai Import',
  //       path: '/simpeg-pegawai-import',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Formula Builder',
  //       path: '/formula-builder',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Datagrid Loadpanel Practice',
  //       path: '/datagrid-loadpanel-practice',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Gaji List Lookup',
  //       path: '/gaji-list-lookup',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Gaji List Pisah',
  //       path: '/gaji-list-pisah',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Buat Gaji Baru',
  //       path: '/gaji-baru',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Riwayat Penggajian',
  //       path: '/gaji-list',
  //       icon: 'folder'
  //     },

  //     {
  //       text: 'Simpeg Pegawai Import',
  //       path: '/simpeg-pegawai-import2',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Pivot Practice',
  //       path: '/pivot-practice'
  //     },
  //     {
  //       text: 'GA DIPAKE Absen List',
  //       path: '/absen-list',
  //     },

  //   ]
  // },

  // {
  //   text: "PRACTICE V3",
  //   icon: "folder",
  //   items: [
  //     {
  //       text: 'Print Gaji Plt',
  //       path: '/print-gaji-plt',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Simpeg Pegawai Add Backup',
  //       path: '/simpeg-pegawai-add-backup',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Simpeg Pegawai Detail Backup2',
  //       path: '/simpeg-pegawai-detail-backup2',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Dxlookup Value Changed',
  //       path: '/dxlookup-value-changed',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Dxlookup Value Changed Datagrid',
  //       path: '/dxlookup-value-changed-datagrid',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Practice Chart Doughnut',
  //       path: '/practice-chart-doughnut',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Practice Parent Child Template',
  //       path: '/practice-parent-child-template',
  //       icon: 'folder'
  //     },
  //     {
  //       text: 'Practice Dialog',
  //       path: '/practice-dialog',
  //       icon: 'folder'
  //     }

  //   ],
  // },
  // {
  //   text: 'Practice Loading Screen',
  //   path: '/practice-loading-screen',
  //   icon: 'folder'
  // }, ,
  // {
  //   text: 'Check Tgl Pegawai Import',
  //   path: '/check-tgl-pegawai-import',
  //   icon: 'folder'
  // }, , , , ,
  // {
  //   text: 'Simpeg Pegawai List Virtual Scroll',
  //   path: '/simpeg-pegawai-list-virtual-scroll',
  //   icon: 'folder'
  // },
  // {
  //   text: 'Simpeg Naik Pangkat List Virtual Scroll',
  //   path: '/simpeg-naik-pangkat-list-virtual-scroll',
  //   icon: 'folder'
  // },
  // {
  //   text: 'Simpeg Kgb List Virtual Scroll',
  //   path: '/simpeg-kgb-list-virtual-scroll',
  //   icon: 'folder', , , , , , ,

  {
    text: "Absen List Customstore",
    path: "/absen-list-customstore",
    icon: "folder",
  },
  {
    text: "Absen List Gabung",
    path: "/absen-list-gabung",
    icon: "folder",
  },
  {
    text: "Pegawai List Custom",
    path: "/pegawai-list-custom",
    icon: "folder",
  },
  {
    text: "Naik Pangkat List Custom",
    path: "/naik-pangkat-list-custom",
    icon: "folder",
  },
  {
    text: "Kgb List Custom",
    path: "/kgb-list-custom",
    icon: "folder",
  },
  {
    text: "Pekerjaan List Custom",
    path: "/pekerjaan-list-custom",
    icon: "folder",
  },
  {
    text: "Transport List Custom",
    path: "/transport-list-custom",
    icon: "folder",
  },
  {
    text: "Pendidikan List Custom",
    path: "/pendidikan-list-custom",
    icon: "folder",
  },
  {
    text: "Naik Pangkat Prediksi List Custom",
    path: "/naik-pangkat-prediksi-list-custom",
    icon: "folder",
  },
  {
    text: "Kgb Prediksi List Custom",
    path: "/kgb-prediksi-list-custom",
    icon: "folder",
  },
  {
    text: "Pensiun List Custom",
    path: "/pensiun-list-custom",
    icon: "folder",
  },
  {
    text: "Absen List Custom",
    path: "/absen-list-custom",
    icon: "folder",
  },
  {
    text: "Absen Input Custom",
    path: "/absen-input-custom",
    icon: "folder",
  },
  {
    text: "Pegawai Detail Custom",
    path: "/pegawai-detail-custom",
    icon: "folder",
  },
  // {
  //   text: 'Gaji Print',
  //   path: '/gaji-print',
  //   icon: 'folder'
  // },
  // {
  //   text: 'GajiRekapPrint',
  //   path: '/gaji-rekap-print',
  //   icon: 'folder'
  // },
  // {
  //   text: 'Gaji History Custom',
  //   path: '/gaji-history-custom',
  //   icon: 'folder'
  // }, , , , , , , , , , , ,
  // {
  //   text: 'Diklat Print Page Break',
  //   path: '/diklat-print-page-break',
  //   icon: 'folder'
  // }, , , , ,

  // {
  //   text: 'Cuti Setting List',
  //   path: '/cuti-setting-list',
  //   icon: 'folder'
  // }
];
